import { useEffect } from "react";

import useProspectSession from "src/hooks/useProspectSession";
import { subscribeConsent } from "src/utils/consent";
import { metaPixelWanted, syncMetaPixel } from "src/utils/meta";

/** Runs the Meta Pixel for prospects only, honoring the visitor's opt-out. */
export default function MetaPixel() {
  const session = useProspectSession();
  const wanted = metaPixelWanted({
    ...session,
    hostname: window.location.hostname,
  });

  useEffect(() => {
    if (wanted === undefined) return;
    syncMetaPixel(wanted);
    return subscribeConsent(() => syncMetaPixel(wanted));
  }, [wanted]);

  return null;
}
